import React, { useState } from 'react';
import { Input, Spin } from 'antd';
import { UserAddOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, AccountCard, ActionMenus } from '..';
import Wrapper from './style';
import RemoveMember from './removeMember';
import { isAccessGroupExist } from '../../utils/accessGroup';
import { adminAccessGroupSlugs } from '../../configs/accessGroup';

const actions = ({ setShowRemoveMember, setSelectedMember, member }) => {
  return [
    {
      text: 'Remove',
      icon: <DeleteOutlined />,
      id: 2,
      type: 'danger',
      onClick: () => {
        setSelectedMember(member);
        setShowRemoveMember(true);
      },
    },
  ];
};

const Index = (props) => {
  const {
    members = [],
    teamName = '',
    onSearch,
    isLoading,
    onClickAddNewMember,
    refetchMemberList,
    teamOwnerId,
  } = props;

  const [showRemoveMember, setShowRemoveMember] = useState(false);
  const [selectedMember, setSelectedMember] = useState();

  const hasAccessInviteRemoveMember = isAccessGroupExist({
    slug: adminAccessGroupSlugs.INVITE_REMOVE_TEAM_MEMBER,
  });

  return (
    <Wrapper>
      {selectedMember && (
        <RemoveMember
          isShow={showRemoveMember}
          onCancel={() => {
            setSelectedMember();
            setShowRemoveMember(false);
          }}
          teamName={teamName}
          userName={selectedMember?.user?.name}
          teamId={selectedMember?.team?.id}
          user={selectedMember?.user}
          refetchMemberList={refetchMemberList}
        />
      )}
      <div className="component_team_info_title">
        {hasAccessInviteRemoveMember && (
          <div className="component_team_info_btn">
            <Button
              type="default"
              className="component_info_btn"
              onClick={onClickAddNewMember}
            >
              <UserAddOutlined />
              Add New
            </Button>
          </div>
        )}
        <Input
          placeholder="Search by name or email"
          className="component_team_member_search"
          onChange={onSearch}
        />
      </div>
      {isLoading && <Spin />}
      {!isLoading && members?.length > 0 && (
        <div className="component_team_info_content">
          {members?.map((item) => {
            return (
              <div className="component_team_content_item" key={item?.id}>
                <AccountCard
                  name={item?.user?.name}
                  description={item?.user?.email}
                />
                <div className="component_team_content_item_information">
                  <div className="font-paragraph_medium black2">
                    {item?.role?.name}
                  </div>
                  {teamOwnerId !== item.user.id && (
                    <div className="component_team_content_right_section">
                      {hasAccessInviteRemoveMember && (
                        <ActionMenus
                          items={actions({
                            setShowRemoveMember,
                            setSelectedMember,
                            member: item,
                          })}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Wrapper>
  );
};

export default Index;
